(function () {
  var form = document.getElementById('CustomSignupForm');
  var submitBtn = document.getElementById('register-submit');
  var formErrors = document.getElementById('FormErrors');
  var marketingCheckbox = document.getElementById('MarketingOptIn');
  var termsCheckbox = document.getElementById('TermsAgree');

  var fields = {
    FirstName: document.getElementById('FirstName'),
    LastName: document.getElementById('LastName'),
    Email: document.getElementById('Email'),
    Phone: document.getElementById('Phone'),
    dob: document.getElementById('dob'),
    CreatePassword: document.getElementById('CreatePassword'),
    ConfirmPassword: document.getElementById('ConfirmPassword')
  };

  // Guard: if any expected element is missing, log exactly which one
  // instead of throwing and silently killing the rest of the script.
  var missing = [];
  if (!form) missing.push('CustomSignupForm');
  if (!submitBtn) missing.push('register-submit');
  if (!marketingCheckbox) missing.push('MarketingOptIn');
  if (!termsCheckbox) missing.push('TermsAgree');
  Object.keys(fields).forEach(function (key) {
    if (!fields[key]) missing.push(key + ' (fields.' + key + ')');
  });

  if (missing.length) {
    console.error('custom-signup.js: missing expected element id(s) — check these against custom-signup.liquid:', missing.join(', '));
    return;
  }

  var today = new Date();

  function yearsAgoDate(years) {
    var year = today.getFullYear() - years;
    var month = today.getMonth();

    // Handle February 29 when the target year isn't a leap year.
    var lastDay = new Date(year, month + 1, 0).getDate();
    var day = Math.min(today.getDate(), lastDay);

    return (
      year + '-' +
      String(month + 1).padStart(2, '0') + '-' +
      String(day).padStart(2, '0')
    );
  }

  fields.dob.required = true;
  fields.dob.min = yearsAgoDate(100);
  fields.dob.max = yearsAgoDate(10);

  var turnstileToken = null;

  window.onTurnstileLoad = function () {
    if (!window.turnstile) {
      console.error('custom-signup.js: Turnstile script did not load (window.turnstile is undefined)');
      return;
    }
    window.turnstile.render('#TurnstileWidget', {
      // sitekey: '0x4AAAAAADWrxredv01fx7Tt',
      sitekey: '0x4AAAAAAEGokRBeSxyFl2Dt',
      callback: window.onTurnstileSuccess,
      'expired-callback': window.onTurnstileExpired
    });
  };

  window.onTurnstileSuccess = function (token) {
    turnstileToken = token;
    showError('Turnstile', true);
  };

  window.onTurnstileExpired = function () {
    turnstileToken = null;
  };

  var validators = {
    FirstName: function () {
      return fields.FirstName.value.trim().length > 0;
    },
    LastName: function () {
      return fields.LastName.value.trim().length > 0;
    },
    Email: function () {
      var v = fields.Email.value.trim();
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    },
    Phone: function () {
      if (!window.libphonenumber) {
        // Library failed to load — fail closed rather than silently
        // accepting a number that Shopify would later reject.
        console.error('custom-signup.js: libphonenumber-js did not load');
        return false;
      }

      var digits = fields.Phone.value.replace(/\D/g, '');

      if (digits.length !== 10) return false;

      // Validates against real assigned NANP area codes / exchange ranges —
      // the same underlying rule set Shopify's customerCreate API checks —
      // so fake-but-structurally-valid numbers (e.g. 2933789290) are caught
      // here instead of failing later in the Azure Function -> Shopify step.
      return window.libphonenumber.isValidPhoneNumber(digits, 'US');
    },
    dob: function () {
      var value = fields.dob.value;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;

      var parts = value.split('-');
      var year = Number(parts[0]);
      var month = Number(parts[1]);
      var day = Number(parts[2]);
      var entered = new Date(year, month - 1, day);

      // Reject invalid calendar dates.
      if (
        entered.getFullYear() !== year ||
        entered.getMonth() !== month - 1 ||
        entered.getDate() !== day
      ) {
        return false;
      }

      return value >= fields.dob.min && value <= fields.dob.max;
    },
    CreatePassword: function () {
      var v = fields.CreatePassword.value;
      return v.length >= 8 && /\d/.test(v);
    },
    ConfirmPassword: function () {
      return fields.ConfirmPassword.value.length > 0 &&
             fields.ConfirmPassword.value === fields.CreatePassword.value;
    }
  };

  function showError(fieldId, isValid) {
    var errorSpan = document.querySelector('[data-error-for="' + fieldId + '"]');
    var input = fields[fieldId];

    if (input) {
      if (isValid) {
        input.classList.remove('field-invalid');
      } else {
        input.classList.add('field-invalid');
      }
    }
    if (errorSpan) {
      errorSpan.classList.toggle('show', !isValid);
    }
  }

  function validateField(fieldId) {
    var isValid = validators[fieldId]();
    showError(fieldId, isValid);
    return isValid;
  }

  function validateAll() {
    var allValid = true;

    Object.keys(validators).forEach(function (fieldId) {
      if (!validateField(fieldId)) allValid = false;
    });

    if (!termsCheckbox.checked) {
      showError('TermsAgree', false);
      allValid = false;
    } else {
      showError('TermsAgree', true);
    }

    if (!turnstileToken) {
      showError('Turnstile', false);
      allValid = false;
    }

    return allValid;
  }

  function scrollToFirstError() {
    var target = document.querySelector('.field-invalid') || document.querySelector('.field-error-msg.show');
    if (!target) return;

    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    // Delay focus slightly so it doesn't fight with the smooth-scroll animation.
    setTimeout(function () {
      if (typeof target.focus === 'function') {
        target.focus();
      }
    }, 300);
  }

  fields.Phone.addEventListener('input', function (e) {
    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 10);
  });

  Object.keys(fields).forEach(function (fieldId) {
    fields[fieldId].addEventListener('blur', function () {
      validateField(fieldId);
    });
    fields[fieldId].addEventListener('input', function () {
      if (validators[fieldId]()) {
        showError(fieldId, true);
      }
    });
  });

  fields.CreatePassword.addEventListener('input', function () {
    if (fields.ConfirmPassword.value) {
      showError('ConfirmPassword', validators.ConfirmPassword());
    }
  });

  termsCheckbox.addEventListener('change', function () {
    if (termsCheckbox.checked) showError('TermsAgree', true);
  });

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    formErrors.style.display = 'none';

    if (!validateAll()) {
      scrollToFirstError();
      return;
    }

    var payload = {
      firstName: fields.FirstName.value.trim(),
      lastName: fields.LastName.value.trim(),
      email: fields.Email.value.trim(),
      phone: fields.Phone.value.replace(/\D/g, ''),
      dob: fields.dob.value,
      password: fields.CreatePassword.value,
      emailOptIn: marketingCheckbox.checked,
      turnstileToken: turnstileToken
    };

    // Support either an <input> or a <button> submit element.
    var isInputButton = submitBtn.tagName === 'INPUT';
    var originalLabel = isInputButton ? submitBtn.value : submitBtn.textContent;

    function setSubmitLabel(label) {
      if (isInputButton) {
        submitBtn.value = label;
      } else {
        submitBtn.textContent = label;
      }
    }

    function resetAfterFailure(message) {
      formErrors.textContent = message;
      formErrors.style.display = 'block';
      formErrors.scrollIntoView({ behavior: 'smooth', block: 'center' });

      submitBtn.disabled = false;
      setSubmitLabel(originalLabel);

      // A new attempt should use a fresh verification token.
      turnstileToken = null;

      if (window.turnstile) {
        window.turnstile.reset('#TurnstileWidget');
      }
    }

    submitBtn.disabled = true;
    setSubmitLabel('Creating account…');

    try {
      var res = await fetch('/apps/signup', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      var data = await res.json();

      if (res.ok) {
        window.location.assign('/pages/registration-success');
        return;
      }

      resetAfterFailure(
        (data && typeof data.message === 'string' && data.message) ||
        'We could not complete your registration. Please try again.'
      );
    } catch (err) {
      resetAfterFailure(
        'We could not confirm your registration. Please try again.'
      );
    }
  });
})();